import React, { useState } from "react";
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Warning, Close } from "@mui/icons-material";
import BackWithArrow from "../../common/BackWithArrow";
import OverDueIconDesign from "../../common/OverDueIconDesign";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export default function OverdueCalibrationsButton() {
  const [open, setOpen] = useState(false);

  const dummyData = [
    { id: 1, equipment: "EQ1", dueDate: "2023-09-30", department: "Quality" },
    {
      id: 2,
      equipment: "EQ2",
      dueDate: "2023-09-28",
      department: "Production",
    },
    { id: 3, equipment: "EQ3", dueDate: "2023-09-25", department: "Design" },
  ];

  return (
    <>
      <OverDueIconDesign
        //variant="outlined"
        // color="warning"
        //startIcon={<Warning />}
        onClick={() => setOpen(true)}
      />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
        fullScreen
      >
        <BackWithArrow onBack={() => setOpen(false)} />

        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>ID</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Equipment</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Due Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Department</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dummyData.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{item.equipment}</TableCell>
                      <TableCell>{item.dueDate}</TableCell>
                      <TableCell>{item.department}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", p: 3 }}>
          <Button
            onClick={() => setOpen(false)}
            variant="contained"
            size="large"
            sx={{
              backgroundColor: "#4F46E5",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#FFFFFF",
                color: "#4F46E5",
              },
            }}
            startIcon={<RestartAltIcon color="#4F46E5" />}
          >
            Reset
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
